import React from 'react'
import './Codes.css'

const Codes = () => (
    <div className="codes">
        <ul>
            <li><a href="https://codepen.io/JorgeGWD/" target="_blank" rel="noopener noreferrer" aria-label="CodePen"><i className="fab fa-codepen"></i></a></li>
            <li><a href="https://github.com/JorgeGWD" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><i className="fab fa-github"></i></a></li>
        </ul>
    </div>
)

export default Codes